"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4776],{

/***/ 87920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SelectedFilters_SelectedFilters; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Chip/index.js + 2 modules
var Chip = __webpack_require__(17781);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/currencyFormatter/index.js
var currencyFormatter = __webpack_require__(93837);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var utils_build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SelectedFilters/SelectedFilters.styles.js


var _templateObject, _templateObject2;





var SelectedFilters_styles_Button = (0,styled_components_browser_esm["default"])(Button/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    bg: 'unset',
    color: 'text.primary',
    fontSize: 2,
    fontWeight: 'medium',
    height: ['auto'],
    lineHeight: 'display',
    noHover: true,
    width: ['auto']
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  &:hover {\n    text-decoration: underline;\n    color: ", ";\n  }\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.getTextColor)('primary')(props);
}, stereo_ui_styles_build_esm.color, index_esm.typography, index_esm.layout);
var Title = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    fontSize: 2,
    fontWeight: 'bold',
    lineHeight: 'display'
  }, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)([""])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SelectedFilters/SelectedFilters.js



var _excluded = ["hidden"];










function getUrlFilterTypes(structure) {
  var _structure$route;
  var filters = (structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.filters) || [];
  return filters.reduce(function (types, filter) {
    return filter.origin === 'url' ? [].concat((0,toConsumableArray/* default */.Z)(types), [filter.type]) : types;
  }, []);
}
function review(_ref) {
  var data = _ref.data;
  if ((data == null ? void 0 : data.type) !== 'review') return data;
  return [{
    label: (data == null ? void 0 : data.selectedMin) && "".concat(data.selectedMin, " estrela").concat(data.selectedMin > 1 ? 's' : ''),
    selected: !!(data == null ? void 0 : data.selectedMin),
    slug: data == null ? void 0 : data.selectedMin,
    type: data == null ? void 0 : data.slug,
    unique: true
  }];
}
function basic(_ref2) {
  var _data$values;
  var data = _ref2.data;
  return (data == null ? void 0 : (_data$values = data.values) == null ? void 0 : _data$values.map(function (value) {
    return (0,esm_extends/* default */.Z)({}, value, {
      type: data == null ? void 0 : data.slug
    });
  })) || data;
}
function getPriceRangeLabel(_ref3) {
  var selectedMin = _ref3.selectedMin,
    selectedMax = _ref3.selectedMax;
  if (selectedMin && selectedMax) {
    return "De ".concat((0,currencyFormatter/* default */.Z)({
      value: (0,utils_build_esm/* parsePriceFilter */.il)(selectedMin)
    }), " at\xE9 ").concat((0,currencyFormatter/* default */.Z)({
      value: (0,utils_build_esm/* parsePriceFilter */.il)(selectedMax)
    }));
  }
  if (selectedMin) {
    return "A partir de ".concat((0,currencyFormatter/* default */.Z)({
      value: (0,utils_build_esm/* parsePriceFilter */.il)(selectedMin)
    }));
  }
  if (selectedMax) {
    return "At\xE9 ".concat((0,currencyFormatter/* default */.Z)({
      value: (0,utils_build_esm/* parsePriceFilter */.il)(selectedMax)
    }));
  }
  return '';
}
function price(_ref4) {
  var data = _ref4.data;
  if ((data == null ? void 0 : data.type) !== 'price') return data;
  return [{
    label: getPriceRangeLabel(data),
    selected: !!(data == null ? void 0 : data.selectedMin) || !!(data == null ? void 0 : data.selectedMax),
    selectedMax: data == null ? void 0 : data.selectedMax,
    selectedMin: data == null ? void 0 : data.selectedMin,
    slug: (data == null ? void 0 : data.selectedMin) || (data == null ? void 0 : data.selectedMax),
    type: data == null ? void 0 : data.slug
  }];
}
var plugins = [basic, review, price];
function CloseCircleFilled(_ref5) {
  var onClick = _ref5.onClick;
  return react.createElement(esm/* Icon */.JO$, {
    name: "CloseCircleFilled",
    width: 16,
    height: 16,
    color: "light",
    cursor: "pointer",
    onClick: onClick,
    "data-testid": "CloseCircleFilled"
  });
}
 false ? 0 : void 0;
function SelectedFilters(_ref6) {
  var staticProps = _ref6["static"],
    data = _ref6.data,
    structure = _ref6.structure;
  var urlFilters = getUrlFilterTypes(structure);
  var _staticProps$title = staticProps.title,
    title = _staticProps$title === void 0 ? 'Filtros Selecionados' : _staticProps$title;
  var _ref7 = (data == null ? void 0 : data.search) || {},
    searchFilters = _ref7.filters;
  var filters = (0,react.useMemo)(function () {
    return searchFilters == null ? void 0 : searchFilters.reduce(function (acc, filter) {
      return [].concat((0,toConsumableArray/* default */.Z)(acc), (0,toConsumableArray/* default */.Z)(utils_build_esm/* composite.apply */.h$.apply(void 0, plugins)({
        data: filter
      })));
    }, []);
  }, [searchFilters]);
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var query = structure.query;
  var _getSelectedCategoryFilter = function getSelectedCategoryFilter(filter) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'category';
    var selectedSubcategoryFilter = ((filter == null ? void 0 : filter.values) || []).find(function (_ref8) {
      var selected = _ref8.selected;
      return selected;
    });
    if (selectedSubcategoryFilter) return _getSelectedCategoryFilter(selectedSubcategoryFilter, 'subcategory');
    if (type !== 'category') return (0,esm_extends/* default */.Z)({}, filter, {
      type: type
    });
    return null;
  };
  var selectedFilters = filters == null ? void 0 : filters.reduce(function (acc, filter) {
    if ((filter == null ? void 0 : filter.selected) && !urlFilters.includes(filter.type)) {
      if (filter.type === 'category') {
        var selectedSubcategoryFilter = _getSelectedCategoryFilter(filter);
        return [].concat((0,toConsumableArray/* default */.Z)(acc), [(0,esm_extends/* default */.Z)({}, filter, {
          hidden: Boolean(selectedSubcategoryFilter)
        }), selectedSubcategoryFilter]);
      }
      return [].concat((0,toConsumableArray/* default */.Z)(acc), [filter]);
    }
    return acc;
  }, []).filter(Boolean);
  var handleRemoveFilter = function handleRemoveFilter() {
    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var type = item.type,
      id = item.id,
      slug = item.slug,
      selected = item.selected,
      unique = item.unique,
      selectedMax = item.selectedMax,
      selectedMin = item.selectedMin;
    publish('productlist:filter:remove', item);
    var path = (0,utils_build_esm/* buildFilterUrl */.P2)({
      max: selectedMax,
      min: selectedMin,
      query: query,
      selected: selected,
      structure: structure,
      type: type,
      unique: unique,
      value: id || slug
    });
    (0,utils_build_esm/* routePush */.dY)({
      path: path,
      spa: true
    });
  };
  var handleClearFilters = function handleClearFilters() {
    publish('productlist:filter:clean');
    var path = (0,utils_build_esm/* urlCleanSelectedFilters */.Ld)(selectedFilters, query, structure);
    (0,utils_build_esm/* routePush */.dY)({
      path: path,
      spa: true
    });
  };
  if (selectedFilters == null ? void 0 : selectedFilters.length) {
    return react.createElement(Box/* default */.Z, {
      width: [1],
      py: 3,
      px: 2,
      bg: "background.white"
    }, react.createElement(Flex/* default */.Z, {
      p: [2],
      justifyContent: "space-between",
      flexDirection: "columns"
    }, react.createElement(Title, {
      "data-testid": "selected-filters"
    }, title), react.createElement(SelectedFilters_styles_Button, {
      "data-testid": "clean-filter",
      onClick: handleClearFilters
    }, "Limpar filtros")), react.createElement(Flex/* default */.Z, {
      mx: [2],
      flexGrow: 3,
      flexWrap: "wrap"
    }, selectedFilters.map(function (_ref9, position) {
      var hidden = _ref9.hidden,
        filter = (0,objectWithoutProperties/* default */.Z)(_ref9, _excluded);
      return !hidden && react.createElement(Chip/* default */.Z, {
        key: "".concat(filter.type, "-").concat(filter.slug),
        type: "checkbox",
        clickable: true,
        autoSize: true,
        bg: "secondary",
        as: "div",
        color: "base",
        m: 1,
        endIcon: react.createElement(CloseCircleFilled, {
          onClick: function onClick() {
            return handleRemoveFilter((0,esm_extends/* default */.Z)({}, filter, {
              position: position
            }));
          }
        })
      }, filter.label);
    })));
  }
  return null;
}
SelectedFilters.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
 false ? 0 : void 0;
/* harmony default export */ var SelectedFilters_SelectedFilters = (SelectedFilters);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SelectedFilters/index.js


/***/ }),

/***/ 97172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ SelectionCouponCard_SelectionCouponCard; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/CouponCard/index.js + 2 modules
var CouponCard = __webpack_require__(704);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SelectionCouponCard/utils.js
var findCouponTag = function findCouponTag(tags) {
  if (!tags) return null;
  return tags.find(function (tag) {
    return tag.type === 'coupon';
  });
};
var findProductWithCoupon = function findProductWithCoupon(products) {
  if (!products) return null;
  return products.find(function (product) {
    var _product$seller;
    return findCouponTag((_product$seller = product.seller) == null ? void 0 : _product$seller.tags);
  });
};
var formattedDate = function formattedDate(date) {
  if (!date) return null;
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short'
  });
};
var getCouponInfo = function getCouponInfo(product) {
  var _findCouponTag = findCouponTag(product.seller.tags),
    code = _findCouponTag.code,
    discountType = _findCouponTag.discountType,
    discountValue = _findCouponTag.discountValue;
  return {
    code: code,
    discountType: discountType,
    discountValue: discountValue
  };
};
var isValidDate = function isValidDate(date) {
  var parsedDate = new Date(date * 1000);
  return {
    isValid: !Number.isNaN(parsedDate.getTime()) && parsedDate >= new Date(),
    parsedDate: parsedDate
  };
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SelectionCouponCard/SelectionCouponCard.js








var SelectionCouponCard = function SelectionCouponCard(_ref) {
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var title = staticProps.title,
    products = staticProps.products,
    endDate = staticProps.endDate,
    type = staticProps.type;
  var isCouponType = type === 'coupon';
  var productWithCoupon = findProductWithCoupon(products);
  var isValidEndDate = isValidDate(endDate);
  if (!productWithCoupon || !isValidEndDate || !isCouponType) return null;
  var _ref2 = getCouponInfo(productWithCoupon) || {},
    code = _ref2.code,
    discountType = _ref2.discountType,
    discountValue = _ref2.discountValue;
  var handleView = function handleView() {
    publish('coupon:viewItem', {
      couponName: code,
      screenName: structure == null ? void 0 : structure.name,
      sectionTitle: title
    });
  };
  var handleClick = function handleClick() {
    publish('coupon:selectItem', {
      couponName: code,
      screenName: structure == null ? void 0 : structure.name,
      sectionTitle: title
    });
  };
  (0,react.useEffect)(function () {
    handleView();
  }, []);
  return react.createElement(CouponCard/* default */.Z, (0,esm_extends/* default */.Z)({
    headerText: title
  }, staticProps), react.createElement(molecules/* CouponCodeCopy */.F7, {
    code: code.toUpperCase(),
    discountType: discountType,
    discountValue: discountValue,
    expirationDate: formattedDate(isValidEndDate == null ? void 0 : isValidEndDate.parsedDate),
    auxiliaryText: "Copie o cupom e cole na revis\xE3o. V\xE1lido at\xE9",
    onCopySuccess: handleClick
  }));
};
 false ? 0 : void 0;
SelectionCouponCard.defaultProps = {
  "static": {},
  structure: {}
};
SelectionCouponCard.ssr = false;
SelectionCouponCard.displayName = 'SelectionCouponCard';
/* harmony default export */ var SelectionCouponCard_SelectionCouponCard = ((0,withLayoutProps/* default */.Z)(SelectionCouponCard));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SelectionCouponCard/index.js


/***/ }),

/***/ 49997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SellerChatAndFollowButtons_SellerChatAndFollowButtons; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var graphql_build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerChatAndFollowButtons/SellerChatAndFollowButtons.styles.js

var _templateObject;


var ButtonStyled = (0,styled_components_browser_esm["default"])(Button/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  border-color: ", ";\n  box-shadow: ", ";\n  color: ", ";\n"])), function (props) {
  return props.padding;
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.borderColor;
}, function (props) {
  return props.boxShadow;
}, function (props) {
  return props.color;
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerChatAndFollowButtons/SellerFollowButton/SellerFollowButton.js




function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }






var SellerFollowButton = function SellerFollowButton(_ref) {
  var customerId = _ref.customerId,
    sellerId = _ref.sellerId,
    styleButtonProps = _ref.styleButtonProps;
  var _useState = (0,react.useState)({}),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    buttonFollower = _useState2[0],
    setButtonFollower = _useState2[1];
  var _useChatIsCustomerFol = (0,graphql_build_esm.useChatIsCustomerFollowingSeller)({
      customerId: customerId,
      sellerId: sellerId
    }),
    customerFollower = _useChatIsCustomerFol.resultCustomerFollower;
  (0,react.useEffect)(function () {
    setButtonFollower({
      buttonLabel: (customerFollower == null ? void 0 : customerFollower.isFollowing) ? 'Seguindo' : 'Seguir',
      isFollowing: customerFollower == null ? void 0 : customerFollower.isFollowing
    });
  }, [customerId, sellerId, customerFollower]);
  var _useChatSetFollowStat = (0,graphql_build_esm.useChatSetFollowStatus)(),
    fetchSetFollower = _useChatSetFollowStat.fetchSetFollower;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var handleFollowSeller = function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
      var result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchSetFollower({
              customerId: customerId,
              followSeller: !buttonFollower.isFollowing,
              sellerId: sellerId
            });
          case 2:
            result = _context.sent;
            setButtonFollower({
              buttonLabel: result.isFollowing ? 'Seguindo' : 'Seguir',
              isFollowing: result.isFollowing
            });
            publish('chat-conversation:followSeller:click', {
              isFollowing: result.isFollowing,
              sellerId: sellerId
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleFollowSeller() {
      return _ref2.apply(this, arguments);
    };
  }();
  return react.createElement(ButtonStyled, (0,esm_extends/* default */.Z)({
    size: "small",
    color: "primary",
    variation: "outline",
    startIcon: buttonFollower.isFollowing ? react.createElement(esm/* CheckThin */.NGQ, {
      width: 15,
      height: 15,
      color: styleButtonProps.color
    }) : react.createElement(esm/* Addition */.kjA, {
      width: 15,
      height: 15,
      color: styleButtonProps.color
    }),
    onClick: handleFollowSeller,
    "data-testid": "follow-seller",
    centered: true
  }, styleButtonProps), buttonFollower.buttonLabel);
};
 false ? 0 : void 0;
SellerFollowButton.defaultProps = {
  customerId: '',
  sellerId: '',
  styleButtonProps: {}
};
/* harmony default export */ var SellerFollowButton_SellerFollowButton = (SellerFollowButton);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerChatAndFollowButtons/SellerFollowButton/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerChatAndFollowButtons/SellerChatAndFollowButtons.js









var SellerChatAndFollowButtons = function SellerChatAndFollowButtons(_ref) {
  var customerId = _ref.customerId,
    customStyles = _ref.customStyles,
    isChatEnabled = _ref.isChatEnabled,
    productId = _ref.productId,
    sellerId = _ref.sellerId,
    userIsLogged = _ref.userIsLogged;
  var isFirstParty = sellerId === 'magazineluiza';
  var openChat = function openChat() {
    (0,build_esm/* routePush */.dY)({
      path: "/chat-com-lojista/p/".concat(sellerId, "/").concat(productId),
      spa: true
    });
  };
  var styleButtonProps = customStyles !== null && customStyles !== void 0 ? customStyles : {};
  return !isFirstParty && isChatEnabled ? react.createElement(Flex/* default */.Z, {
    lineHeight: 1,
    gap: 2
  }, react.createElement(Flex/* default */.Z, {
    justifyContent: "flex-start"
  }, react.createElement(ButtonStyled, (0,esm_extends/* default */.Z)({
    size: "small",
    color: "primary",
    variation: "outline",
    startIcon: react.createElement(esm/* Chat */.enk, {
      width: 20,
      height: 20
    }),
    onClick: openChat,
    "data-testid": "chat-with-seller",
    centered: true
  }, styleButtonProps), "Fale com lojista")), userIsLogged ? react.createElement(Flex/* default */.Z, {
    justifyContent: "flex-end"
  }, react.createElement(SellerFollowButton_SellerFollowButton, {
    customerId: customerId,
    sellerId: sellerId,
    styleButtonProps: styleButtonProps
  })) : null) : null;
};
 false ? 0 : void 0;
SellerChatAndFollowButtons.defaultProps = {
  customerId: '',
  customStyles: null,
  isChatEnabled: false,
  productId: '',
  sellerId: '',
  userIsLogged: false
};
SellerChatAndFollowButtons.ssr = true;
/* harmony default export */ var SellerChatAndFollowButtons_SellerChatAndFollowButtons = ((0,withLayoutProps/* default */.Z)(SellerChatAndFollowButtons));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerChatAndFollowButtons/index.js


/***/ }),

/***/ 57797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SellerDelivery_SellerDelivery; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/index.js + 5 modules
var organisms_SellerDelivery = __webpack_require__(30143);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDelivery/SellerDelivery.js






var SellerDelivery = function SellerDelivery(_ref) {
  var product = _ref.data.product,
    _ref$static = _ref["static"],
    href = _ref$static.href,
    spa = _ref$static.spa,
    disableSellerClick = _ref$static.disableSellerClick,
    showDialog = _ref$static.showDialog,
    logoIconColor = _ref$static.logoIconColor;
  var _ref2 = product || {},
    seller = _ref2.seller;
  var path = "".concat(href).concat(seller == null ? void 0 : seller.id, "/");
  var props = {
    disableSellerClick: disableSellerClick,
    seller: (0,esm_extends/* default */.Z)({}, seller, {
      href: path
    }),
    showDialog: showDialog
  };
  var onOffersClick = function onOffersClick(e) {
    e.preventDefault();
    (0,esm/* routePush */.dY)({
      path: path,
      spa: spa
    });
  };
  if (spa) {
    props.onOffersClick = onOffersClick;
  }
  return react.createElement(organisms_SellerDelivery/* default */.Z, (0,esm_extends/* default */.Z)({
    logoIconColor: logoIconColor
  }, props));
};
 false ? 0 : void 0;
SellerDelivery.defaultProps = {
  data: {},
  "static": {
    href: '',
    logoIconColor: '',
    showDialog: false,
    spa: false
  }
};
SellerDelivery.dataSource = {
  product: {
    query: 'ProductQuery'
  }
};
SellerDelivery.ssr = true;
/* harmony default export */ var SellerDelivery_SellerDelivery = ((0,withLayoutProps/* default */.Z)(SellerDelivery));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDelivery/index.js


/***/ }),

/***/ 2719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ModalContent_ModalContent; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/commons/masks/cnpjMask.js
var cnpjMask = __webpack_require__(17370);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/SellerScore/SellerScore.js + 2 modules
var SellerScore = __webpack_require__(3716);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js + 6 modules
var organisms = __webpack_require__(28167);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/ScoreDetails/constants.js
var ScoreDetailsTexts = [{
  description: 'Pedidos que foram despachados e entregues no prazo previsto.',
  icon: 'DeliveryDefault',
  title: 'Pedidos entregues no prazo'
}, {
  description: 'Total de cancelamentos de pedidos solicitados pelos clientes ou por essa loja por diferentes motivos: falta de peças, produto com avarias, produto diferente ou pelo recebimento fora do prazo.',
  icon: 'PackageAlert',
  title: 'Cancelamentos'
}, {
  description: 'Avalia o tempo que a loja leva para responder aos clientes nos canais de atendimento: Protocolo, Chat com o Cliente e Perguntas e Respostas',
  icon: 'CustomerContact',
  title: 'Agilidade no atendimento'
}];
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/utils.js
var utils = __webpack_require__(77833);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/ScoreDetails/ScoreDetails.styles.js

var _templateObject;



var ShowDetails = styled_components_browser_esm["default"].button(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  text-transform: none;\n  width: 100%;\n  justify-content: space-between;\n  margin-top: ", "px;\n  padding: ", "px;\n  color: ", ";\n  font-size: ", "px;\n  border-radius: ", ";\n  font-weight: ", ";\n  background-color: ", ";\n  border: ", ";\n  cursor: pointer;\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('space.3')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('space.2')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.getTextColor)('attributeLabel')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('fontSizes.1')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('radii.default')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('fontWeights.regular')(props);
}, function (props) {
  return (0,utils/* getPaletteColor */.ow)('background.transparent')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('borders.0')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/ScoreDetails/ScoreDetails.js









var ScoreDetailsContent = function ScoreDetailsContent() {
  return react.createElement(atoms/* Box */.xu, {
    "data-testid": "score-details-content",
    p: [3, 0]
  }, react.createElement(atoms/* Text */.xv, {
    mt: 2,
    mb: 2,
    fontWeight: "regular"
  }, "A nota de reputa\xE7\xE3o refere-se a v\xE1rios crit\xE9rios na experi\xEAncia de compra oferecida aos clientes. Saiba o que levamos a considera\xE7\xE3o."), ScoreDetailsTexts.map(function (_ref) {
    var description = _ref.description,
      icon = _ref.icon,
      title = _ref.title;
    return react.createElement(atoms/* Grid */.rj, {
      key: icon,
      gridAutoFlow: "column",
      gap: 2,
      py: 12
    }, react.createElement(esm/* Icon */.JO$, {
      fill: "background.primary",
      name: icon,
      width: 33,
      height: 30
    }), react.createElement(atoms/* Box */.xu, null, react.createElement(atoms/* Text */.xv, {
      fontWeight: "bold",
      fontSize: [3, 2]
    }, title), react.createElement(atoms/* Text */.xv, {
      mt: 2,
      fontSize: [1, 0]
    }, description)));
  }));
};
function ScoreDetails(_ref2) {
  var seller = _ref2.seller,
    _ref2$static = _ref2["static"],
    scoreDetailsTitle = _ref2$static.scoreDetailsTitle,
    scoreDetailsSidebar = _ref2$static.scoreDetailsSidebar,
    isMobile = _ref2.isMobile;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    showScoreDetail = _useState2[0],
    setShowScoreDetails = _useState2[1];
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var eventPublish = function eventPublish() {
    return publish('sellerdetails:click:about:rating', {
      seller: seller
    });
  };
  var handleShowDetails = function handleShowDetails() {
    eventPublish();
    setShowScoreDetails(true);
  };
  return isMobile ? react.createElement(react.Fragment, null, react.createElement(ShowDetails, {
    full: true,
    mt: 3,
    mb: 3,
    "data-testid": "showScoreDetails",
    onClick: handleShowDetails
  }, scoreDetailsTitle, react.createElement(esm/* Icon */.JO$, {
    name: "ChevronRight",
    fill: "background.primary"
  })), react.createElement(organisms/* Sidebar */.YE, {
    direction: "right",
    visible: showScoreDetail,
    fullScreen: true,
    title: scoreDetailsSidebar,
    "data-testid": "ScoreSidebar"
  }, react.createElement(organisms/* Sidebar.Header */.YE.Header, {
    startIcon: "ArrowBack",
    onClick: function onClick() {
      return setShowScoreDetails(false);
    }
  }, scoreDetailsSidebar), react.createElement(ScoreDetailsContent, null))) : react.createElement(atoms/* Box */.xu, {
    "data-testid": "score-details-accordion",
    maxWidth: "340px"
  }, react.createElement(atoms/* Box */.xu, {
    mt: 3
  }, react.createElement(atoms/* HorizontalRule */.bo, null)), react.createElement(atoms/* Accordion */.UQ, {
    closeIcon: "ChevronUp",
    title: scoreDetailsTitle,
    open: showScoreDetail,
    onClick: function onClick() {
      setShowScoreDetails(!showScoreDetail);
      eventPublish();
    },
    fontWeight: "regular",
    openIcon: "ChevronDown"
  }, react.createElement(ScoreDetailsContent, null)), react.createElement(atoms/* Box */.xu, {
    mb: 3
  }, react.createElement(atoms/* HorizontalRule */.bo, null)));
}
ScoreDetails.defaultProps = {
  isMobile: false,
  seller: '',
  "static": {
    scoreDetailsSidebar: '',
    scoreDetailsTitle: ''
  }
};
 false ? 0 : void 0;
/* harmony default export */ var ScoreDetails_ScoreDetails = (ScoreDetails);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/index.js
var stereo_ui_build_esm = __webpack_require__(87302);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/GuaranteeText/SellerGuaranteeText.js



var SellerGuaranteeText = function SellerGuaranteeText(_ref) {
  var isMagaluCompany = _ref.isMagaluCompany;
  var getTextIntro = function getTextIntro() {
    return isMagaluCompany ? 'Este produto é vendido por uma empresa do grupo Magalu' : 'Este produto é vendido por um lojista parceiro';
  };
  var getTextBody = function getTextBody() {
    return isMagaluCompany ? 'Todas as empresas do nosso ecossistema compartilham do mesmo propósito, oferecendo uma experiência diferenciada.' : 'Nossos parceiros são selecionados e avaliados por critérios de excelência no serviço.';
  };
  return react.createElement(stereo_ui_build_esm/* Text */.xvT, {
    fontSize: 1,
    fontWeight: "regular",
    color: "attributeLabel",
    lineHeight: "16px",
    "data-testid": "GuaranteeText"
  }, getTextIntro(), "\xA0e o\xA0", react.createElement(stereo_ui_build_esm/* Text */.xvT, {
    as: "span",
    fontWeight: "bold"
  }, "Magalu garante a entrega.\xA0"), getTextBody(), "\xA0Certificamos as vendas com nota fiscal e garantimos produtos originais. Se tem no Magalu, t\xE1 garantido!");
};
SellerGuaranteeText.defaultProps = {
  isMagaluCompany: false
};
 false ? 0 : void 0;
/* harmony default export */ var GuaranteeText_SellerGuaranteeText = (SellerGuaranteeText);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/GuaranteeText/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/ModalContent/ModalContent.utils.js

var getFormattedSellerAddress = function getFormattedSellerAddress() {
  var addressDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _addressDetails$addre = addressDetails.address,
    addressInfo = _addressDetails$addre === void 0 ? {} : _addressDetails$addre;
  var address = addressInfo.address,
    number = addressInfo.number,
    city = addressInfo.city,
    state = addressInfo.state,
    district = addressInfo.district,
    zipcode = addressInfo.zipcode;
  var formattedAddress = [];
  if (address && number) {
    formattedAddress.push("".concat(address, ", ").concat(number));
  }
  if (city && state) {
    var formatedDistrict = district ? "".concat(district, " - ") : '';
    formattedAddress.push("".concat(formatedDistrict).concat(city, "/").concat(state));
  }
  if (zipcode) {
    formattedAddress.push((0,stereo_ui_build_esm/* zipcodeMask */.CKO)(zipcode));
  }
  return formattedAddress;
};
var regulatoryData = function regulatoryData(regulatoryType, data) {
  if (data) return !data[regulatoryType].notApply;
  return null;
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/ModalContent/ModalContent.styles.js

var ModalContent_styles_templateObject, _templateObject2, _templateObject3, _templateObject4;




var DataInfo = (0,styled_components_browser_esm["default"])(atoms/* Text */.xv).attrs({
  color: 'attributeLabel',
  fontSize: 1
})(ModalContent_styles_templateObject || (ModalContent_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  line-height: 16px;\n"])));
var DataTitle = (0,styled_components_browser_esm["default"])(atoms/* Text */.xv).attrs({
  color: 'attributeLabel',
  fontSize: [2, 1],
  fontWeight: 'bold',
  lineHeight: 1.2
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var Hr = (0,styled_components_browser_esm["default"])(atoms/* HorizontalRule */.bo)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 24px 0;\n  background-color: ", ";\n"])), function (props) {
  return (0,utils/* getPaletteColor */.ow)('background.darker')(props);
});
var Offers = styled_components_browser_esm["default"].a(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  margin: 0 auto 0 auto;\n  width: fit-content;\n  padding: ", "px;\n  color: ", ";\n  font-size: ", "px;\n  border-radius: ", ";\n  font-weight: ", ";\n  background-color: ", ";\n  padding-left: 13px;\n  cursor: pointer;\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('space.1')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.getTextColor)('primary')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('fontSizes.2')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('radii.default')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('fontWeights.bold')(props);
}, function (props) {
  return (0,utils/* getPaletteColor */.ow)('background.darker')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/ModalContent/ModalContent.js












function ModalContent(_ref) {
  var _details$regulatoryDa, _details$regulatoryDa2, _seller$details;
  var seller = _ref.seller,
    product = _ref.product,
    scoreDetailsTitle = _ref.scoreDetailsTitle,
    scoreDetailsSidebar = _ref.scoreDetailsSidebar,
    showDialog = _ref.showDialog,
    spa = _ref.spa,
    href = _ref.href;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var details = seller.details;
  var path = "".concat(href).concat(seller == null ? void 0 : seller.id, "/");
  var magaluCompany = build_esm/* magaluCompanies */.p5[seller == null ? void 0 : seller.id];
  var isMagaluCompany = !!magaluCompany;
  var showInternationalSeller = (0,build_esm/* isInternationalPrice */.xx)(product);
  var docSeller = function docSeller() {
    return !showInternationalSeller ? {
      label: 'CNPJ',
      value: (0,cnpjMask/* default */.Z)(details == null ? void 0 : details.documentNumber)
    } : {
      label: 'ID do Lojista',
      value: details == null ? void 0 : details.shippingDocumentNumber
    };
  };
  var detailsSections = [docSeller(), (details == null ? void 0 : details.legalName) && {
    label: 'Razão Social',
    value: details.legalName
  }, (details == null ? void 0 : details.address) && {
    label: 'Endereço',
    value: getFormattedSellerAddress(details).map(function (text) {
      return react.createElement(DataInfo, {
        key: text
      }, text);
    })
  }, regulatoryData('anvisa', details == null ? void 0 : details.regulatoryData) && {
    label: 'Autorização ANVISA',
    value: details == null ? void 0 : (_details$regulatoryDa = details.regulatoryData) == null ? void 0 : _details$regulatoryDa.anvisa.items.map(function (item) {
      return react.createElement("span", {
        key: item
      }, item);
    })
  }, regulatoryData('mapa', details == null ? void 0 : details.regulatoryData) && {
    label: 'Autorização MAPA',
    value: details == null ? void 0 : (_details$regulatoryDa2 = details.regulatoryData) == null ? void 0 : _details$regulatoryDa2.mapa.items.map(function (item) {
      return react.createElement("span", {
        key: item
      }, item);
    })
  }];
  var onOffersClick = function onOffersClick(e) {
    publish('sellerdetails:offers:link:click', {
      seller: seller
    });
    if (spa) {
      e.preventDefault();
      (0,build_esm/* routePush */.dY)({
        path: path,
        spa: spa
      });
    }
  };
  return react.createElement(atoms/* Box */.xu, {
    p: !showDialog ? 3 : undefined,
    "data-testid": "seller-modal-content"
  }, !showDialog && react.createElement(atoms/* Text */.xv, {
    fontWeight: "bold",
    color: "attributeLabel",
    fontSize: 4,
    mb: 4
  }, "Informa\xE7\xF5es da loja parceira"), react.createElement(SellerScore/* default */.Z, {
    "static": {
      isMagaluCompany: isMagaluCompany,
      seller: seller
    }
  }), ((_seller$details = seller.details) == null ? void 0 : _seller$details.score) && !isMagaluCompany && react.createElement(ScoreDetails_ScoreDetails, {
    "static": {
      scoreDetailsSidebar: scoreDetailsSidebar,
      scoreDetailsTitle: scoreDetailsTitle
    },
    isMobile: !showDialog,
    seller: seller
  }), react.createElement(atoms/* Grid */.rj, {
    gridAutoFlow: "column",
    gap: 2,
    py: 24
  }, react.createElement(esm/* Icon */.JO$, {
    name: "Guarantee",
    width: 33,
    height: 30
  }), react.createElement(atoms/* Box */.xu, {
    width: showDialog ? 300 : undefined
  }, !showInternationalSeller && react.createElement(GuaranteeText_SellerGuaranteeText, {
    isMagaluCompany: isMagaluCompany
  }), showInternationalSeller && react.createElement(atoms/* Text */.xv, {
    fontSize: 1,
    fontWeight: "regular",
    color: "attributeLabel",
    lineHeight: "16px",
    "data-testid": "GuaranteeText"
  }, "O Magalu garante a sua compra, do pedido \xE0 entrega."))), react.createElement(Offers, {
    href: path,
    onClick: onOffersClick,
    "data-testid": "offers-link"
  }, "Ver mais produtos da loja", react.createElement(esm/* Icon */.JO$, {
    color: "background.magablu",
    name: "ChevronRight",
    ml: 2
  })), react.createElement(Hr, null), react.createElement(atoms/* Flex */.kC, {
    gap: 3,
    flexDirection: "column"
  }, details && detailsSections.filter(function (value) {
    return !!value;
  }).map(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      label = _ref2.label,
      value = _ref2.value;
    return react.createElement(atoms/* Box */.xu, {
      key: label
    }, react.createElement(DataTitle, null, label), react.createElement(DataInfo, null, value));
  })));
}
ModalContent.defaultProps = {
  href: '',
  product: {},
  scoreDetailsSidebar: '',
  scoreDetailsTitle: '',
  seller: {
    description: '',
    details: {
      address: {}
    },
    id: ''
  },
  showDialog: false,
  spa: false
};
 false ? 0 : void 0;
ModalContent.ssr = true;
/* harmony default export */ var ModalContent_ModalContent = (ModalContent);

/***/ }),

/***/ 87487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SellerDetails_SellerDetails; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/index.js + 5 modules
var SellerDelivery = __webpack_require__(30143);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/ModalContent/ModalContent.js + 7 modules
var ModalContent = __webpack_require__(2719);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/ModalContent/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/SellerDetails.js









var SellerDetails = function SellerDetails(_ref) {
  var product = _ref.data.product,
    _ref$static = _ref["static"],
    _ref$static$disableSe = _ref$static.disableSellerClick,
    disableSellerClick = _ref$static$disableSe === void 0 ? false : _ref$static$disableSe,
    href = _ref$static.href,
    logoIconColor = _ref$static.logoIconColor,
    scoreDetailsTitle = _ref$static.scoreDetailsTitle,
    scoreDetailsSidebar = _ref$static.scoreDetailsSidebar,
    showDialog = _ref$static.showDialog,
    spa = _ref$static.spa;
  var eventName = 'sellershowdetail:open';
  var seller = product.seller,
    variationId = product.variationId;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe,
    publish = _usePublisher.publish;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    showSellerDetailContent = _useState2[0],
    setShowSellerDetailContent = _useState2[1];
  var handleShowDialog = function handleShowDialog() {
    return setShowSellerDetailContent(true);
  };
  var handleCloseDialog = function handleCloseDialog() {
    return setShowSellerDetailContent(false);
  };
  (0,react.useEffect)(function () {
    subscribe(eventName, handleShowDialog);
    return function () {
      unsubscribe(eventName, handleShowDialog);
    };
  });
  var internationalPartner = build_esm/* internationalPartners */.JS[seller.id];
  var internationalPartnerProps = internationalPartner ? {
    internationalPartner: true,
    partnerColor: internationalPartner.color,
    partnerLogo: internationalPartner.logo
  } : {};
  var props = (0,esm_extends/* default */.Z)({
    disableSellerClick: disableSellerClick,
    href: href,
    onCloseModalContent: handleCloseDialog,
    product: product,
    scoreDetailsSidebar: scoreDetailsSidebar,
    scoreDetailsTitle: scoreDetailsTitle,
    seller: seller,
    showDialog: showDialog,
    showSellerDetailContent: showSellerDetailContent,
    spa: spa
  }, internationalPartnerProps);
  var handleSellerClick = function handleSellerClick() {
    publish('sellerdetails:open:modal:click', {
      seller: seller,
      variationId: variationId
    });
    publish(eventName);
  };
  return react.createElement(SellerDelivery/* default */.Z, (0,esm_extends/* default */.Z)({
    logoIconColor: logoIconColor,
    onSellerClick: handleSellerClick,
    modal: {
      content: react.createElement(ModalContent/* default */.Z, props),
      title: 'Informações da loja parceira',
      titleStyle: {
        color: 'attributeLabel',
        fontWeight: 'bold',
        pl: 0
      }
    }
  }, props));
};
 false ? 0 : void 0;
SellerDetails.defaultProps = {
  data: {
    product: {}
  },
  "static": {
    href: '',
    logoIconColor: '',
    scoreDetailsSidebar: '',
    scoreDetailsTitle: '',
    showDialog: false,
    spa: false
  }
};
SellerDetails.dataSource = {
  product: {
    query: 'ProductQuery'
  }
};
SellerDetails.ssr = true;
/* harmony default export */ var SellerDetails_SellerDetails = ((0,withLayoutProps/* default */.Z)(SellerDetails));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/index.js


/***/ }),

/***/ 14181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SellerPageBanner_SellerPageBanner; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Carousel/index.js + 4 modules
var Carousel = __webpack_require__(49542);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerPageBanner/SellerPageBanner.styles.js

var _templateObject, _templateObject2, _templateObject3;


var BannerContainer = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n"])));
var Image = (0,styled_components_browser_esm["default"])(ResponsiveImage/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: ", ";\n  width: 100%;\n  object-fit: cover;\n  object-position: ", ";\n  display: block;\n"])), function (_ref) {
  var height = _ref.height;
  return height && height.trim() !== '' ? height : 'auto';
}, function (_ref2) {
  var position = _ref2.position;
  return position;
});
var ImageWrapper = styled_components_browser_esm["default"].div(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: ", ";\n  overflow: hidden;\n  border-radius: 8px;\n"])), function (_ref3) {
  var height = _ref3.height;
  return height || '228px';
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerPageBanner/utils.js
var buildFilters = function buildFilters(banner) {
  var _banner$category, _banner$subCategory, _banner$brand;
  var filters = [];
  if ((_banner$category = banner.category) == null ? void 0 : _banner$category.id) {
    filters.push("category---".concat(banner.category.id));
  }
  if ((_banner$subCategory = banner.subCategory) == null ? void 0 : _banner$subCategory.id) {
    filters.push("subcategory---".concat(banner.subCategory.id));
  }
  if ((_banner$brand = banner.brand) == null ? void 0 : _banner$brand.slug) {
    filters.push("brand---".concat(banner.brand.slug));
  }
  return encodeURIComponent(filters.join('+'));
};
var buildSearchUrl = function buildSearchUrl(sellerId, banner, baseUrl) {
  var filters = buildFilters(banner);
  return "".concat(baseUrl, "/busca/?filters=seller---").concat(sellerId, "&").concat(filters);
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerPageBanner/SellerPageBanner.js







var SellerPageBanner = function SellerPageBanner(_ref) {
  var staticProps = _ref["static"];
  var height = staticProps.height,
    path = staticProps.path,
    position = staticProps.position,
    _staticProps$banners = staticProps.banners,
    banners = _staticProps$banners === void 0 ? [] : _staticProps$banners,
    fallbackImage = staticProps.fallbackImage,
    _staticProps$duration = staticProps.duration,
    duration = _staticProps$duration === void 0 ? 2000 : _staticProps$duration,
    _staticProps$interval = staticProps.interval,
    interval = _staticProps$interval === void 0 ? 3000 : _staticProps$interval,
    _staticProps$auto = staticProps.auto,
    auto = _staticProps$auto === void 0 ? true : _staticProps$auto,
    sellerId = staticProps.sellerId,
    baseUrl = staticProps.baseUrl;
  var firstBanner = Array.isArray(banners) && banners.length > 0 ? banners[0] : null;
  var linkUrl = firstBanner && sellerId ? buildSearchUrl(sellerId, firstBanner, baseUrl) : path;
  var imageProps = {
    height: height,
    position: position
  };
  var images = [];
  if (Array.isArray(banners) && banners.length > 0) {
    images = banners.map(function (banner) {
      var _banner$images;
      return banner == null ? void 0 : (_banner$images = banner.images) == null ? void 0 : _banner$images.desktop;
    }).filter(Boolean);
  }
  if (images.length === 0 && fallbackImage) {
    images = [fallbackImage];
  }
  if (images.length === 0) {
    return null;
  }
  var showCarousel = images.length > 1;
  return react.createElement(BannerContainer, {
    "data-testId": "banner-seller"
  }, react.createElement(Carousel/* default */.Z, {
    auto: showCarousel ? auto : false,
    gutter: 0,
    insideControls: true,
    interval: interval,
    "data-testid": "banner-seller-carousel",
    showArrowControls: true,
    showControls: false,
    showSlideCount: false,
    transitionDuration: duration
  }, images.map(function (imageSrc) {
    return react.createElement(atoms/* Link */.rU, {
      "data-testId": "banner-seller-link",
      href: linkUrl,
      style: {
        display: 'block',
        width: '100%'
      },
      key: "banner-".concat(imageSrc),
      "aria-label": "Link do banner"
    }, react.createElement(ImageWrapper, {
      height: height
    }, react.createElement(Image, (0,esm_extends/* default */.Z)({
      alt: "Banner p\xE1gina do seller: ".concat(imageSrc),
      key: "banner-".concat(imageSrc)
    }, imageProps, {
      src: imageSrc
    }))));
  })));
};
 false ? 0 : void 0;
SellerPageBanner.defaultProps = {
  "static": {}
};
/* harmony default export */ var SellerPageBanner_SellerPageBanner = (SellerPageBanner);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerPageBanner/index.js


/***/ }),

/***/ 80915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SellerPageHeader_SellerPageHeader; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var utils_build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/SellerChatAndFollowButtons/index.js + 4 modules
var SellerChatAndFollowButtons = __webpack_require__(49997);
// EXTERNAL MODULE: ../modules/build/esm/hooks/index.js + 14 modules
var hooks = __webpack_require__(1001);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SocialShare/index.js + 2 modules
var SocialShare = __webpack_require__(51382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerPageHeader/SellerPageHeader.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;






var magablu = (0,build_esm.themeGet)('colors.blue');
var white = (0,build_esm.themeGet)('colors.base');
var defaultBackgroundColor = '#F0F3F4';
var Dot = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: ", "px;\n  height: ", "px;\n  background-color: ", ";\n  border-radius: 2px;\n"])), (0,build_esm.themeGet)('space.1'), (0,build_esm.themeGet)('space.1'), (0,build_esm.themeGet)('baseColors.gray.light'));
var HeaderImage = styled_components_browser_esm["default"].img(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-height: 300px;\n  min-height: 120px;\n  width: 100%;\n  object-fit: cover;\n"])));
var SellerBox = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 1;\n  gap: ", "px;\n"])), (0,build_esm.themeGet)('space.3'));
var SellerButton = (0,styled_components_browser_esm["default"])(Button/* default */.Z)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: ", "px;\n    text-transform: none !important;\n  }\n"])), (0,build_esm.themeGet)('space.2'));
var SellerFlex = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  min-height: 94px;\n  width: 100%;\n  padding: ", "px ", "px;\n  background-color: ", ";\n  gap: ", "px;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  align-items: center;\n"])), (0,build_esm.themeGet)('space.3'), (0,build_esm.themeGet)('space.3'), (0,build_esm.getBackgroundColor)('white'), (0,build_esm.themeGet)('space.3'));
var SellerInfoBox = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-flow: column;\n  flex: 1;\n  gap: ", "px;\n"])), (0,build_esm.themeGet)('space.1'));
var SellerLogoImage = styled_components_browser_esm["default"].img(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 48px;\n  width: 48px;\n  object-fit: cover;\n  border: 1px solid #d3dadd;\n  border-radius: ", "px;\n  overflow: hidden;\n"])), (0,build_esm.themeGet)('space.1'));
var SellerShare = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 50%;\n  height: 42px;\n  justify-content: center;\n  width: 42px;\n"])), function (props) {
  var _props$backgroundColo;
  return (_props$backgroundColo = props.backgroundColor) !== null && _props$backgroundColo !== void 0 ? _props$backgroundColo : defaultBackgroundColor;
});
var SellerShareComponent = (0,styled_components_browser_esm["default"])(SocialShare/* default */.Z)(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  height: 32px;\n  width: 32px;\n  & > svg {\n    color: ", ";\n    fill: ", ";\n  }\n  & > div > a {\n    color: ", ";\n    fill: ", ";\n    background-color: ", ";\n  }\n"])), function (props) {
  var _props$backgroundColo2;
  return (_props$backgroundColo2 = props.backgroundColor) !== null && _props$backgroundColo2 !== void 0 ? _props$backgroundColo2 : defaultBackgroundColor;
}, function (props) {
  var _props$iconColor;
  return (_props$iconColor = props.iconColor) !== null && _props$iconColor !== void 0 ? _props$iconColor : magablu;
}, function (props) {
  var _props$iconColor2;
  return (_props$iconColor2 = props.iconColor) !== null && _props$iconColor2 !== void 0 ? _props$iconColor2 : magablu;
}, function (props) {
  var _props$iconColor3;
  return (_props$iconColor3 = props.iconColor) !== null && _props$iconColor3 !== void 0 ? _props$iconColor3 : white;
}, function (props) {
  var _props$iconColor4;
  return (_props$iconColor4 = props.iconColor) !== null && _props$iconColor4 !== void 0 ? _props$iconColor4 : white;
}, function (props) {
  return props.backgroundColor;
});
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerPageHeader/SellerPageHeader.utils.js


var sellerPageShareGenerator = function sellerPageShareGenerator(_ref) {
  var domain = _ref.domain,
    sellerId = _ref.sellerId,
    sellerName = _ref.sellerName;
  var linkParameters = encodeURIComponent('?partner_id=64853&utm_source=seller_page_desk&utm_medium=share');
  var shareText = encodeURIComponent((0,utils_build_esm/* cleanHtml */.ZF)("Vem conferir todas as novidades da loja ".concat(sellerName)));
  var shareTitle = encodeURIComponent('O que é bom merece ser compartilhado!');
  var shareUrl = new URL("".concat(domain, "/lojista/").concat(sellerId).concat(linkParameters)).toString();
  var colorObj = {
    color: 'text.white'
  };
  return [(0,esm_extends/* default */.Z)({}, colorObj, {
    icon: 'Facebook',
    title: 'facebook',
    url: "https://www.facebook.com/sharer/sharer.php?u=".concat(shareUrl)
  }), (0,esm_extends/* default */.Z)({}, colorObj, {
    icon: 'Twitter',
    title: 'twitter',
    url: "https://twitter.com/intent/tweet?text=".concat(shareTitle, "&url=").concat(shareUrl)
  }), (0,esm_extends/* default */.Z)({}, colorObj, {
    icon: 'WhatsApp',
    title: 'whatsapp',
    url: "https://wa.me/?text=".concat(shareUrl)
  }), (0,esm_extends/* default */.Z)({}, colorObj, {
    icon: 'MailOutline',
    title: 'email',
    url: "mailto:?subject=".concat(shareTitle, "&body=").concat(shareText, "%20").concat(shareUrl)
  })];
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerPageHeader/SellerPageHeader.js



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }












var SellerPageHeader_magablu = (0,build_esm.themeGet)('colors.blue');
var SellerPageHeader_white = (0,build_esm.themeGet)('colors.white');
var getCustomStyles = function getCustomStyles(colorPrimary, colorSecondary) {
  return {
    backgroundColor: colorPrimary || SellerPageHeader_magablu,
    borderColor: colorPrimary || SellerPageHeader_magablu,
    borderRadius: '32px',
    boxShadow: colorPrimary || SellerPageHeader_magablu,
    color: colorSecondary || SellerPageHeader_white,
    padding: '18px 12px'
  };
};
var mapSocialShareItems = function mapSocialShareItems(items, colorSecondary) {
  return items.map(function (elem) {
    return {
      Icon: react.createElement(esm/* Icon */.JO$, {
        name: elem.icon,
        color: colorSecondary || 'text.white'
      }),
      title: elem.title,
      url: elem.url
    };
  });
};
var SellerPageHeader = function SellerPageHeader(_ref) {
  var _structure$config, _structure$route;
  var structure = _ref.structure,
    _ref$static = _ref["static"],
    _ref$static2 = _ref$static === void 0 ? {} : _ref$static,
    headerImageUrl = _ref$static2.headerImageUrl,
    sellerName = _ref$static2.sellerName,
    sellerLogoUrl = _ref$static2.sellerLogoUrl,
    oficialStore = _ref$static2.oficialStore,
    followersAmount = _ref$static2.followersAmount,
    salesAmount = _ref$static2.salesAmount,
    style = _ref$static2.style,
    staticDomain = _ref$static2.domain,
    isChatEnabled = _ref$static2.isChatEnabled;
  var _useState = (0,react.useState)({}),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    userData = _useState2[0],
    setUserData = _useState2[1];
  var domain = staticDomain || (structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.domain);
  var sellerId = (structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.sellerId) || '';
  var socialShareItems = sellerPageShareGenerator({
    domain: domain,
    sellerId: sellerId,
    sellerName: sellerName
  });
  var getUserData = (0,react.useCallback)((0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
    var data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0,hooks/* useUserData */.v$)({
            structure: structure
          });
        case 2:
          data = _context.sent;
          setUserData(data);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), []);
  (0,react.useEffect)(function () {
    getUserData();
  }, [getUserData]);
  var customStyles = getCustomStyles(style == null ? void 0 : style.colorPrimary, style == null ? void 0 : style.colorSecondary);
  var formattedSales = salesAmount ? (0,utils_build_esm/* formatNumber */.uf)(salesAmount) : null;
  var mappedSocialItems = mapSocialShareItems(socialShareItems, style == null ? void 0 : style.colorSecondary);
  return react.createElement(Flex/* default */.Z, {
    flexWrap: "wrap",
    width: "100%"
  }, react.createElement(HeaderImage, {
    src: headerImageUrl,
    alt: sellerName || 'Header da Página do Seller'
  }), react.createElement(SellerFlex, null, react.createElement(SellerBox, null, react.createElement(SellerLogoImage, {
    src: sellerLogoUrl,
    alt: sellerName || 'Logo da Página do Seller'
  }), react.createElement(SellerInfoBox, null, sellerName && react.createElement(Text/* default */.Z, {
    fontWeight: "medium",
    fontSize: 4
  }, sellerName), oficialStore && react.createElement(Flex/* default */.Z, {
    gap: "8px",
    width: "322px"
  }, react.createElement(Text/* default */.Z, {
    fontWeight: "medium",
    fontSize: 1
  }, oficialStore), react.createElement(esm/* Icon */.JO$, {
    color: "primary.base",
    height: "16px",
    width: "16px",
    name: "VerifiedBadge"
  })), react.createElement(Flex/* default */.Z, {
    gap: "8px",
    width: "322px",
    alignItems: "center"
  }, followersAmount && react.createElement(Flex/* default */.Z, {
    gap: "8px",
    alignItems: "center"
  }, react.createElement(Text/* default */.Z, {
    fontWeight: "regular",
    fontSize: 1
  }, followersAmount), react.createElement(Dot, null)), formattedSales && react.createElement(Text/* default */.Z, {
    fontWeight: "regular",
    fontSize: 1
  }, formattedSales, " ", "vendas")))), react.createElement(SellerChatAndFollowButtons/* default */.Z, {
    customerId: userData == null ? void 0 : userData.id,
    customStyles: customStyles,
    isChatEnabled: isChatEnabled,
    sellerId: sellerId,
    userIsLogged: userData == null ? void 0 : userData.isLogged
  }), react.createElement(SellerShareComponent, {
    socialItems: mappedSocialItems,
    backgroundColor: (style == null ? void 0 : style.colorPrimary) || null,
    iconColor: (style == null ? void 0 : style.colorSecondary) || null
  })));
};
 false ? 0 : void 0;
SellerPageHeader.defaultProps = {
  "static": {
    isChatEnabled: false
  },
  structure: {
    config: {},
    route: {}
  }
};
SellerPageHeader.ssr = true;
SellerPageHeader.displayName = 'SellerPageHeader';
/* harmony default export */ var SellerPageHeader_SellerPageHeader = ((0,withLayoutProps/* default */.Z)(SellerPageHeader));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerPageHeader/index.js


/***/ }),

/***/ 3716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SellerScore_SellerScore; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/index.js
var esm = __webpack_require__(87302);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/SellerStamp/SellerStamp.js
var SellerStamp = __webpack_require__(25782);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/SellerChatAndFollowButtons/index.js + 4 modules
var SellerChatAndFollowButtons = __webpack_require__(49997);
// EXTERNAL MODULE: ../modules/build/esm/hooks/index.js + 14 modules
var hooks = __webpack_require__(1001);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerScore/SellerScore.utils.js

var getMinimumScoreToShow = function getMinimumScoreToShow() {
  var SHOW_SELLER_SCORE_ABOVE = build_esm/* cookiesConstants.SHOW_SELLER_SCORE_ABOVE */.VD.SHOW_SELLER_SCORE_ABOVE;
  var cookieValue = (0,build_esm/* getCookie */.ej)(SHOW_SELLER_SCORE_ABOVE);
  try {
    var parsedValue = Number(cookieValue);
    return Number.isNaN(parsedValue) ? 0 : parsedValue;
  } catch (_unused) {
    return 0;
  }
};
var getSalesLabel = function getSalesLabel(value) {
  var _findLabels$label;
  var labels = [{
    label: '+1 milhão',
    limit: 1000000
  }, {
    label: '+500mil',
    limit: 500000
  }, {
    label: '+200mil',
    limit: 200000
  }, {
    label: '+100mil',
    limit: 100000
  }, {
    label: '+50mil',
    limit: 50000
  }, {
    label: '+20mil',
    limit: 20000
  }, {
    label: '+10mil',
    limit: 10000
  }, {
    label: '+5mil',
    limit: 5000
  }, {
    label: '+1mil',
    limit: 1000
  }, {
    label: '+500',
    limit: 500
  }, {
    label: '+200',
    limit: 200
  }, {
    label: '+100',
    limit: 100
  }, {
    label: '+50',
    limit: 50
  }, {
    label: '+10',
    limit: 10
  }];
  var findLabels = labels.find(function (faixa) {
    return value >= faixa.limit;
  });
  return (_findLabels$label = findLabels == null ? void 0 : findLabels.label) !== null && _findLabels$label !== void 0 ? _findLabels$label : '';
};
var getSellerRole = function getSellerRole(isMagaluCompany, seller) {
  var _seller$details, _seller$details2, _seller$details3;
  var isNewSeller = (seller == null ? void 0 : (_seller$details = seller.details) == null ? void 0 : _seller$details.score) === null;
  var sellerSince = seller == null ? void 0 : (_seller$details2 = seller.details) == null ? void 0 : _seller$details2.sellerSince;
  var isDocShipping = seller == null ? void 0 : (_seller$details3 = seller.details) == null ? void 0 : _seller$details3.shippingDocumentNumber;
  var sellerYear = sellerSince == null ? void 0 : sellerSince.substr(0, 4);
  if (!isMagaluCompany) {
    if (isNewSeller || !sellerYear) {
      return 'Lojista Magalu';
    }
    return "Lojista Magalu desde ".concat(sellerYear);
  }
  if (isMagaluCompany && isDocShipping) {
    return 'Loja parceiro internacional';
  }
  return 'Loja do grupo Magalu';
};
var handleScoreColor = function handleScoreColor(score) {
  var defaultColor = '#B8C1C4';
  var scoreRanges = [{
    color: defaultColor,
    max: 0
  }, {
    color: '#E3172C',
    max: 1.49
  }, {
    color: '#FD8A25',
    max: 1.99
  }, {
    color: '#EEB510',
    max: 2.49
  }, {
    color: '#F9C52E',
    max: 2.99
  }, {
    color: '#5EBE09',
    max: 3.99
  }, {
    color: '#4EA900',
    max: 5
  }];
  var range = scoreRanges.find(function (_ref) {
    var max = _ref.max;
    return score <= max;
  });
  return range ? range.color : defaultColor;
};

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerScore/SellerScore.styles.js

var _templateObject, _templateObject2;



var IconContainer = (0,styled_components_browser_esm["default"])(esm/* Box */.xuv)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  height: 64px;\n"])));
var NewSellerBadge = (0,styled_components_browser_esm["default"])(esm/* Text */.xvT).attrs({
  bg: 'background.primary',
  borderRadius: 'small',
  color: 'white',
  fontSize: 1,
  p: 1
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-radius: ", ";\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('radii.default')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerScore/SellerScore.js



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }










var MAX_PROGRESS_BAR = 100;
var MAX_SCORE = 5;
var SCORE_VALUE_SCALE = MAX_PROGRESS_BAR / MAX_SCORE;
function SellerScore(_ref) {
  var _seller$details, _structure$route, _magaluCompanies$sell, _seller$details2, _seller$details2$deli, _seller$details3, _seller$details3$deli, _seller$details4, _seller$details4$answ, _seller$details5, _seller$details5$answ, _seller$details6, _seller$details7, _seller$details8, _seller$details9, _seller$details10;
  var _ref$static = _ref["static"],
    isMagaluCompany = _ref$static.isMagaluCompany,
    seller = _ref$static.seller,
    structure = _ref.structure;
  var _useState = (0,react.useState)({}),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    userData = _useState2[0],
    setUserData = _useState2[1];
  var isNewSeller = (seller == null ? void 0 : (_seller$details = seller.details) == null ? void 0 : _seller$details.score) === null;
  var productId = structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.productId;
  var getUserData = (0,react.useCallback)((0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
    var data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0,hooks/* useUserData */.v$)({
            structure: structure
          });
        case 2:
          data = _context.sent;
          setUserData(data);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), []);
  (0,react.useEffect)(function () {
    getUserData();
  }, [getUserData]);
  var sellerRole = getSellerRole(isMagaluCompany, seller);
  var sellerIcon = isMagaluCompany ? (_magaluCompanies$sell = build_esm/* magaluCompanies */.p5[seller.id]) == null ? void 0 : _magaluCompanies$sell.icon : 'https://wx.mlcdn.com.br/site/shared/sellers/third-party.png';
  var labelText = ['Ruim', 'Ótimo'];
  var minimumScoreToShow = getMinimumScoreToShow();
  var getScoreLabel = function getScoreLabel(score) {
    if (score.toFixed(2) <= minimumScoreToShow) return '';
    return "".concat(score.toFixed(2)).substring(0, 3);
  };
  var deliveryRateStatus = seller == null ? void 0 : (_seller$details2 = seller.details) == null ? void 0 : (_seller$details2$deli = _seller$details2.deliveryRate) == null ? void 0 : _seller$details2$deli.status;
  var deliveryRateMessage = seller == null ? void 0 : (_seller$details3 = seller.details) == null ? void 0 : (_seller$details3$deli = _seller$details3.deliveryRate) == null ? void 0 : _seller$details3$deli.message;
  var answerRateStatus = seller == null ? void 0 : (_seller$details4 = seller.details) == null ? void 0 : (_seller$details4$answ = _seller$details4.answerRate) == null ? void 0 : _seller$details4$answ.status;
  var answerRateMessage = seller == null ? void 0 : (_seller$details5 = seller.details) == null ? void 0 : (_seller$details5$answ = _seller$details5.answerRate) == null ? void 0 : _seller$details5$answ.message;
  var sellerTotalSales = seller == null ? void 0 : (_seller$details6 = seller.details) == null ? void 0 : _seller$details6.totalSales;
  var getDeliveryIcon = function getDeliveryIcon() {
    var icons = {
      success: 'DeliverySuccess',
      warning: 'DeliveryWarning'
    };
    return icons[deliveryRateStatus] || 'DeliveryDefault';
  };
  var getAnswerIcon = function getAnswerIcon() {
    var icons = {
      success: 'ChatSuccess',
      warning: 'ChatWarning'
    };
    return icons[answerRateStatus] || 'Chat';
  };
  return react.createElement(esm/* Box */.xuv, null, react.createElement(esm/* Flex */.kCb, {
    gap: 3,
    height: 64,
    mb: isNewSeller && !isMagaluCompany && 10
  }, sellerIcon && react.createElement(IconContainer, null, react.createElement(esm/* Image */.Eep, {
    src: sellerIcon,
    imageWidth: 64,
    imageHeight: 64,
    alt: seller.description,
    "data-testid": "seller-icon"
  }), isNewSeller && !isMagaluCompany && react.createElement(NewSellerBadge, {
    "data-testid": "new-seller"
  }, "Novo")), react.createElement(esm/* Flex */.kCb, {
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    lineHeight: 1,
    gap: 1
  }, react.createElement(esm/* Heading */.X6q, {
    color: "attributeLabel",
    fontWeight: "medium",
    lineHeight: "input",
    fontSize: 3
  }, seller.description), react.createElement(esm/* Text */.xvT, {
    color: "attributeLabel",
    textAlign: "left",
    fontWeight: "regular",
    "data-testid": "seller-role",
    fontSize: 2
  }, sellerRole))), react.createElement(esm/* Box */.xuv, {
    pt: 10,
    pl: 80,
    pb: 20
  }, react.createElement(SellerChatAndFollowButtons/* default */.Z, {
    customerId: userData == null ? void 0 : userData.id,
    isChatEnabled: seller == null ? void 0 : seller.isChatEnabled,
    productId: productId,
    sellerId: seller.id,
    userIsLogged: userData == null ? void 0 : userData.isLogged
  })), ((_seller$details7 = seller.details) == null ? void 0 : _seller$details7.score) && !isMagaluCompany && react.createElement(esm/* Box */.xuv, {
    pt: 26,
    mt: 1,
    flexDirection: "column"
  }, react.createElement(esm/* LinearProgress */.ukE, {
    max: 100,
    height: "16px",
    value: ((_seller$details8 = seller.details) == null ? void 0 : _seller$details8.score) * SCORE_VALUE_SCALE,
    label: getScoreLabel((_seller$details9 = seller.details) == null ? void 0 : _seller$details9.score),
    color: handleScoreColor((_seller$details10 = seller.details) == null ? void 0 : _seller$details10.score),
    bullets: {
      quantity: 5,
      size: 6
    }
  }), react.createElement(esm/* Flex */.kCb, {
    px: 3,
    pt: 1,
    mt: 1,
    justifyContent: "space-between",
    fontWeight: "regular",
    fontSize: 0
  }, labelText == null ? void 0 : labelText.map(function (item) {
    return react.createElement(esm/* Text */.xvT, {
      key: "label-".concat(item),
      color: "#697277"
    }, item);
  })), !isNewSeller && react.createElement(esm/* Flex */.kCb, {
    "data-testid": "seller-stamps"
  }, !!sellerTotalSales && react.createElement(SellerStamp/* default */.Z, {
    iconName: "TotalSales",
    iconDataTestId: "salesIcon",
    title: getSalesLabel(sellerTotalSales),
    message: "Produtos vendidos"
  }), !!deliveryRateMessage && react.createElement(SellerStamp/* default */.Z, {
    iconName: getDeliveryIcon(),
    iconDataTestId: "delivery-".concat(deliveryRateStatus),
    title: "Entrega",
    message: deliveryRateMessage
  }), !!answerRateMessage && react.createElement(SellerStamp/* default */.Z, {
    iconName: getAnswerIcon(),
    iconDataTestId: "answer-".concat(answerRateStatus),
    title: "Atendimento",
    message: answerRateMessage
  }))));
}
SellerScore.defaultProps = {
  "static": {
    isMagaluCompany: false,
    seller: {
      description: '',
      details: {},
      id: ''
    }
  },
  structure: {}
};
 false ? 0 : void 0;
SellerScore.ssr = true;
/* harmony default export */ var SellerScore_SellerScore = ((0,withLayoutProps/* default */.Z)(SellerScore));

/***/ }),

/***/ 25782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7896);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59740);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87302);
/* harmony import */ var _magalu_stereo_ui_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34490);
/* harmony import */ var _hocs_withLayoutProps__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89382);


var _excluded = ["title", "iconDataTestId", "message", "iconName"];





function SellerStamp(_ref) {
  var title = _ref.title,
    iconDataTestId = _ref.iconDataTestId,
    message = _ref.message,
    iconName = _ref.iconName,
    props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    width: 1,
    height: 70,
    mt: 3
  }, props), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
    columnGap: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    "data-testid": "text-container"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui_icons__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO$, {
    name: iconName,
    "data-testid": iconDataTestId,
    width: 32,
    height: 32
  }), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
    pb: 1,
    pt: 2,
    fontWeight: "bold",
    fontSize: 16,
    lineHeight: 1
  }, title), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
    fontSize: "10px",
    lineHeight: 1
  }, message)));
}
SellerStamp.defaultProps = {
  iconDataTestId: '',
  message: '',
  title: ''
};
 false ? 0 : void 0;
SellerStamp.ssr = true;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_hocs_withLayoutProps__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(SellerStamp));

/***/ }),

/***/ 54097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SellerStamp__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _SellerStamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25782);


/***/ }),

/***/ 7202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SellerStoreInfo_SellerStoreInfo; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty.js
var objectDestructuringEmpty = __webpack_require__(33665);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var utils_build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/SellerScore/SellerScore.js + 2 modules
var SellerScore = __webpack_require__(3716);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/utils.js
var utils = __webpack_require__(77833);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerStoreInfo/SellerStoreInfo.styles.js


var _templateObject, _templateObject2;




var Container = (0,styled_components_browser_esm["default"])(atoms/* Box */.xu).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    pt: 3
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-bottom: 3px solid ", ";\n  border-top: 3px solid ", ";\n\n  ", " {\n    border-top: none;\n    border-bottom: 1px solid ", ";\n  }\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.getBorderColor)('light')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.getBorderColor)('light')(props);
}, (0,utils/* getMediaQuery */.aK)('small'), function (props) {
  return (0,stereo_ui_styles_build_esm.getBorderColor)('light')(props);
});
var SellerDetailsStore = (0,styled_components_browser_esm["default"])(atoms/* Text */.xv).attrs(function () {
  return {
    color: 'primary',
    fontWeight: 'medium',
    my: [24, 18],
    px: 2,
    py: 1
  };
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  cursor: pointer;\n\n  ", " {\n    justify-content: flex-start;\n  }\n"])), (0,utils/* getMediaQuery */.aK)('small'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerStoreInfo/SellerStoreInfo.js










var SellerStoreInfo = function SellerStoreInfo(_ref) {
  var product = _ref.data.product,
    props = (0,esm_extends/* default */.Z)({}, ((0,objectDestructuringEmpty/* default */.Z)(_ref["static"]), _ref["static"])),
    structure = _ref.structure;
  var seller = product.seller;
  var magaluCompany = utils_build_esm/* magaluCompanies */.p5[seller == null ? void 0 : seller.id];
  var isMagaluCompany = !!magaluCompany;
  var isMagalu = seller.category === '1p';
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  react.useEffect(function () {
    if (!isMagaluCompany && !isMagalu) {
      publish('sellerdetails:impression', {
        seller: seller
      });
    }
  }, []);
  var onSellerDetailsClick = function onSellerDetailsClick() {
    publish('sellerdetailspdp:open:modal:click', {
      seller: seller
    });
    publish('sellershowdetail:open');
  };
  return !isMagalu && (seller == null ? void 0 : seller.id) && react.createElement(Container, (0,esm_extends/* default */.Z)({
    "data-testid": "seller-modal-content"
  }, props), react.createElement(atoms/* Text */.xv, {
    fontWeight: "bold",
    color: "attributeLabel",
    fontSize: 3,
    mb: 3
  }, "Informa\xE7\xF5es da Loja"), react.createElement(SellerScore/* default */.Z, {
    "static": {
      isMagaluCompany: isMagaluCompany,
      seller: seller
    },
    structure: structure
  }), react.createElement(SellerDetailsStore, {
    role: "button",
    fontSize: [2, 1],
    onClick: onSellerDetailsClick,
    "data-testid": "sellerDetailsStore-link",
    mx: [0, 0, 'auto']
  }, "Ver mais informa\xE7\xF5es da loja", react.createElement(esm/* Icon */.JO$, {
    color: "background.magablu",
    name: "ChevronRight",
    ml: 2
  })));
};
SellerStoreInfo.defaultProps = {
  data: {
    product: {
      seller: {
        category: '',
        description: '',
        id: ''
      }
    }
  },
  "static": {},
  structure: {}
};
 false ? 0 : void 0;
SellerStoreInfo.ssr = true;
/* harmony default export */ var SellerStoreInfo_SellerStoreInfo = (SellerStoreInfo);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerStoreInfo/index.js


/***/ }),

/***/ 48903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SeoCategoryTreeLinks_SeoCategoryTreeLinks; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoCategoryTreeLinks/SeoCategoryTreeLinksDesktop/SeoCategoryTreeLinksDesktop.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var Column = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 1;\n"])));
var GroupTitle = styled_components_browser_esm["default"].a(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  font: 600 14px/16px 'Magalu UI', Tahoma, sans-serif;\n  color: #697277;\n  text-decoration: none;\n  margin-bottom: 8px;\n  margin-top: 16px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])));
var LinkItem = styled_components_browser_esm["default"].a(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  font: 400 14px/16px 'Magalu UI', Tahoma, sans-serif;\n  color: #697277;\n  text-decoration: none;\n  margin-bottom: 8px;\n  padding-left: 0;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])));
var LinksContainer = styled_components_browser_esm["default"].div(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  gap: 16px;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoCategoryTreeLinks/SeoCategoryTreeLinksDesktop/SeoCategoryTreeLinksDesktop.js




var buildItems = function buildItems(groups) {
  return groups.reduce(function (items, group) {
    return [].concat((0,toConsumableArray/* default */.Z)(items), [{
      href: group.href,
      label: group.label,
      linksCount: (group.subtree || []).length,
      type: 'title'
    }], (0,toConsumableArray/* default */.Z)((group.subtree || []).map(function (link) {
      return {
        href: link.href,
        label: link.label,
        type: 'link'
      };
    })));
  }, []);
};
var adjustEnd = function adjustEnd(items, offset, intendedEnd) {
  var lastIdx = intendedEnd - 1;
  var last = items[lastIdx];
  if (last && last.type === 'title' && last.linksCount >= 1 && lastIdx > offset) {
    return lastIdx;
  }
  var penIdx = intendedEnd - 2;
  var pen = items[penIdx];
  if (pen && pen.type === 'title' && pen.linksCount >= 2 && penIdx > offset) {
    return penIdx;
  }
  return intendedEnd;
};
var distributeItems = function distributeItems(items, columns) {
  var total = items.length;
  var base = Math.floor(total / columns);
  var extra = total % columns;
  var indices = Array.from({
    length: columns
  }, function (_, i) {
    return i;
  });
  return indices.reduce(function (_ref, col) {
    var cols = _ref.cols,
      offset = _ref.offset;
    var intendedSize = base + (col < extra ? 1 : 0);
    var isLast = col === columns - 1;
    var end = isLast ? total : adjustEnd(items, offset, offset + intendedSize);
    return {
      cols: [].concat((0,toConsumableArray/* default */.Z)(cols), [items.slice(offset, end)]),
      offset: end
    };
  }, {
    cols: [],
    offset: 0
  }).cols;
};
var SeoCategoryTreeLinksDesktop = function SeoCategoryTreeLinksDesktop(_ref2) {
  var columns = _ref2.columns,
    groups = _ref2.groups,
    onLinkClick = _ref2.onLinkClick;
  var columnItems = distributeItems(buildItems(groups), columns);
  return react.createElement(LinksContainer, null, columnItems.map(function (items, colIdx) {
    return (react.createElement(Column, {
        key: colIdx
      }, items.map(function (_ref3) {
        var href = _ref3.href,
          label = _ref3.label,
          type = _ref3.type;
        return type === 'title' ? react.createElement(GroupTitle, {
          key: "title-".concat(href),
          href: href,
          onClick: function onClick(e) {
            return onLinkClick(e, href);
          }
        }, label) : react.createElement(LinkItem, {
          key: "link-".concat(href),
          href: href,
          onClick: function onClick(e) {
            return onLinkClick(e, href);
          }
        }, label);
      }))
    );
  }));
};
 false ? 0 : void 0;
SeoCategoryTreeLinksDesktop.defaultProps = {
  columns: 4,
  groups: [],
  onLinkClick: function onLinkClick() {}
};
/* harmony default export */ var SeoCategoryTreeLinksDesktop_SeoCategoryTreeLinksDesktop = (SeoCategoryTreeLinksDesktop);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoCategoryTreeLinks/SeoCategoryTreeLinksDesktop/index.js

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoCategoryTreeLinks/SeoCategoryTreeLinksMobile/SeoCategoryTreeLinksMobile.styles.js

var SeoCategoryTreeLinksMobile_styles_templateObject, SeoCategoryTreeLinksMobile_styles_templateObject2, SeoCategoryTreeLinksMobile_styles_templateObject3, SeoCategoryTreeLinksMobile_styles_templateObject4, _templateObject5, _templateObject6, _templateObject7;

var AccordionContainer = styled_components_browser_esm["default"].div(SeoCategoryTreeLinksMobile_styles_templateObject || (SeoCategoryTreeLinksMobile_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 12px 0;\n\n  &:first-child {\n    padding-top: 0;\n  }\n"])));
var AccordionContent = styled_components_browser_esm["default"].div(SeoCategoryTreeLinksMobile_styles_templateObject2 || (SeoCategoryTreeLinksMobile_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: hidden;\n  transition: max-height 0.3s ease-out;\n  max-height: ", ";\n"])), function (_ref) {
  var open = _ref.open;
  return open ? '500px' : '0px';
});
var AccordionHeader = styled_components_browser_esm["default"].div(SeoCategoryTreeLinksMobile_styles_templateObject3 || (SeoCategoryTreeLinksMobile_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var GroupTitleLink = styled_components_browser_esm["default"].a(SeoCategoryTreeLinksMobile_styles_templateObject4 || (SeoCategoryTreeLinksMobile_styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font: 600 14px/16px 'Magalu UI', Tahoma, sans-serif;\n  color: #697277;\n  text-decoration: none;\n  flex: 1;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])));
var SeoCategoryTreeLinksMobile_styles_LinkItem = styled_components_browser_esm["default"].a(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  font: 400 14px/16px 'Magalu UI', Tahoma, sans-serif;\n  color: #697277;\n  text-decoration: none;\n  margin-bottom: 8px;\n  margin-top: 8px;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])));
var ToggleButton = styled_components_browser_esm["default"].button(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  appearance: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding: 4px;\n\n  svg {\n    transition: transform 0.3s ease;\n    fill: #697277;\n\n    ", "\n  }\n"])), function (_ref2) {
  var open = _ref2.open;
  return open && (0,styled_components_browser_esm.css)(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n        transform: rotate(180deg);\n      "])));
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoCategoryTreeLinks/SeoCategoryTreeLinksMobile/SeoCategoryTreeLinksMobile.js







var SeoCategoryTreeLinksMobile = function SeoCategoryTreeLinksMobile(_ref) {
  var groups = _ref.groups,
    onLinkClick = _ref.onLinkClick;
  var _useState = (0,react.useState)({}),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    openGroups = _useState2[0],
    setOpenGroups = _useState2[1];
  var toggleGroup = function toggleGroup(href) {
    return setOpenGroups(function (prev) {
      return (0,esm_extends/* default */.Z)({}, prev, (0,defineProperty/* default */.Z)({}, href, !(prev == null ? void 0 : prev[href])));
    });
  };
  return react.createElement(react.Fragment, null, groups.map(function (_ref2) {
    var href = _ref2.href,
      label = _ref2.label,
      subtree = _ref2.subtree;
    return react.createElement(AccordionContainer, {
      key: href
    }, react.createElement(AccordionHeader, null, react.createElement(GroupTitleLink, {
      href: href,
      onClick: function onClick(e) {
        return onLinkClick(e, href);
      }
    }, label), (subtree == null ? void 0 : subtree.length) > 0 && react.createElement(ToggleButton, {
      type: "button",
      open: openGroups == null ? void 0 : openGroups[href],
      onClick: function onClick() {
        return toggleGroup(href);
      },
      "aria-expanded": !!(openGroups == null ? void 0 : openGroups[href]),
      "aria-label": "".concat((openGroups == null ? void 0 : openGroups[href]) ? 'Fechar' : 'Abrir', " ").concat(label),
      "data-testid": "toggle-group-".concat(href)
    }, react.createElement(build_esm/* Icon */.JO$, {
      name: "ChevronDown",
      width: 16,
      height: 16
    }))), (subtree == null ? void 0 : subtree.length) > 0 && react.createElement(AccordionContent, {
      open: !!(openGroups == null ? void 0 : openGroups[href])
    }, subtree.map(function (link) {
      return react.createElement(SeoCategoryTreeLinksMobile_styles_LinkItem, {
        key: link.href,
        href: link.href,
        onClick: function onClick(e) {
          return onLinkClick(e, link.href);
        }
      }, link.label);
    })));
  }));
};
 false ? 0 : void 0;
SeoCategoryTreeLinksMobile.defaultProps = {
  groups: [],
  onLinkClick: function onLinkClick() {}
};
/* harmony default export */ var SeoCategoryTreeLinksMobile_SeoCategoryTreeLinksMobile = (SeoCategoryTreeLinksMobile);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoCategoryTreeLinks/SeoCategoryTreeLinksMobile/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoCategoryTreeLinks/SeoCategoryTreeLinks.styles.js

var SeoCategoryTreeLinks_styles_templateObject, SeoCategoryTreeLinks_styles_templateObject2, SeoCategoryTreeLinks_styles_templateObject3, SeoCategoryTreeLinks_styles_templateObject4, SeoCategoryTreeLinks_styles_templateObject5, SeoCategoryTreeLinks_styles_templateObject6;

var Card = styled_components_browser_esm["default"].div(SeoCategoryTreeLinks_styles_templateObject || (SeoCategoryTreeLinks_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 16px;\n\n  ", "\n"])), function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile && (0,styled_components_browser_esm.css)(SeoCategoryTreeLinks_styles_templateObject2 || (SeoCategoryTreeLinks_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n      margin: 8px;\n    "])));
});
var CollapsibleContent = styled_components_browser_esm["default"].div(SeoCategoryTreeLinks_styles_templateObject3 || (SeoCategoryTreeLinks_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: hidden;\n  position: relative;\n  transition: max-height 0.3s ease;\n  max-height: ", ";\n\n  ", "\n"])), function (_ref2) {
  var collapsedHeight = _ref2.collapsedHeight,
    contentHeight = _ref2.contentHeight,
    isExpanded = _ref2.isExpanded;
  return isExpanded ? "".concat(contentHeight, "px") : "".concat(collapsedHeight, "px");
}, function (_ref3) {
  var isExpanded = _ref3.isExpanded,
    isOverflowing = _ref3.isOverflowing;
  return isOverflowing && !isExpanded && (0,styled_components_browser_esm.css)(SeoCategoryTreeLinks_styles_templateObject4 || (SeoCategoryTreeLinks_styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n      &::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        height: 48px;\n        background: linear-gradient(rgba(255, 255, 255, 0), #fff);\n        pointer-events: none;\n      }\n    "])));
});
var SeeMoreButton = styled_components_browser_esm["default"].button(SeoCategoryTreeLinks_styles_templateObject5 || (SeoCategoryTreeLinks_styles_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  appearance: none;\n  background: none;\n  border: none;\n  color: #0086ff;\n  cursor: pointer;\n  display: block;\n  font: 600 14px/16px 'Magalu UI', Tahoma, sans-serif;\n  margin: 16px auto 0;\n  padding: 0;\n"])));
var Title = styled_components_browser_esm["default"].h2(SeoCategoryTreeLinks_styles_templateObject6 || (SeoCategoryTreeLinks_styles_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font: 600 16px/18px 'Magalu UI', Tahoma, sans-serif;\n  color: #697277;\n  margin: 0 0 16px 0;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoCategoryTreeLinks/SeoCategoryTreeLinks.js








var SeoCategoryTreeLinks = function SeoCategoryTreeLinks(_ref) {
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var _staticProps$collapse = staticProps.collapsedHeight,
    collapsedHeight = _staticProps$collapse === void 0 ? 320 : _staticProps$collapse,
    columns = staticProps.columns,
    linkGroups = staticProps.linkGroups;
  var groups = linkGroups == null ? void 0 : linkGroups.subtree;
  var label = linkGroups == null ? void 0 : linkGroups.label;
  var contentRef = (0,react.useRef)(null);
  var innerRef = (0,react.useRef)(null);
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = (0,react.useState)(0),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    contentHeight = _useState4[0],
    setContentHeight = _useState4[1];
  var _useState5 = (0,react.useState)(false),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    isOverflowing = _useState6[0],
    setIsOverflowing = _useState6[1];
  (0,react.useEffect)(function () {
    if (!contentRef.current) return undefined;
    var measure = function measure() {
      var scrollHeight = contentRef.current.scrollHeight;
      setContentHeight(scrollHeight);
      setIsOverflowing(scrollHeight > collapsedHeight);
    };
    measure();
    if (typeof ResizeObserver === 'undefined' || !innerRef.current) {
      return undefined;
    }
    var observer = new ResizeObserver(measure);
    observer.observe(innerRef.current);
    return function () {
      return observer.disconnect();
    };
  }, [groups, collapsedHeight]);
  if (!groups || groups.length === 0) return null;
  var onLinkClick = function onLinkClick(e, href) {
    e.preventDefault();
    (0,esm/* routePush */.dY)({
      path: href,
      spa: true
    });
  };
  var isMobile = (structure == null ? void 0 : structure.device) === 'mobile';
  return react.createElement(Card, {
    isMobile: isMobile
  }, label && react.createElement(Title, null, label), react.createElement(CollapsibleContent, {
    ref: contentRef,
    collapsedHeight: collapsedHeight,
    contentHeight: contentHeight,
    isExpanded: isExpanded,
    isOverflowing: isOverflowing
  }, react.createElement("div", {
    ref: innerRef
  }, isMobile ? react.createElement(SeoCategoryTreeLinksMobile_SeoCategoryTreeLinksMobile, {
    groups: groups,
    onLinkClick: onLinkClick
  }) : react.createElement(SeoCategoryTreeLinksDesktop_SeoCategoryTreeLinksDesktop, {
    columns: columns,
    groups: groups,
    onLinkClick: onLinkClick
  }))), isOverflowing && react.createElement(SeeMoreButton, {
    type: "button",
    "aria-expanded": isExpanded,
    "data-testid": "seo-category-tree-links-toggle",
    onClick: function onClick() {
      return setIsExpanded(function (prev) {
        return !prev;
      });
    }
  }, isExpanded ? 'Ver menos' : 'Ver mais'));
};
SeoCategoryTreeLinks.ssr = true;
 false ? 0 : void 0;
SeoCategoryTreeLinks.defaultProps = {
  "static": {
    collapsedHeight: 320,
    columns: 4,
    linkGroups: {}
  },
  structure: {}
};
/* harmony default export */ var SeoCategoryTreeLinks_SeoCategoryTreeLinks = ((0,withLayoutProps/* default */.Z)(SeoCategoryTreeLinks));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoCategoryTreeLinks/index.js


/***/ }),

/***/ 66646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SeoLinkList_SeoLinkList; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoLinkList/SeoLinkList.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var Container = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  padding: 16px;\n"])), function (_ref) {
  var _theme$colors;
  var theme = _ref.theme;
  return ((_theme$colors = theme.colors) == null ? void 0 : _theme$colors.background) || '#fff';
});
var Link = styled_components_browser_esm["default"].a(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])), function (_ref2) {
  var _theme$colors2;
  var theme = _ref2.theme;
  return ((_theme$colors2 = theme.colors) == null ? void 0 : _theme$colors2.textSecondary) || '#666';
});
var List = styled_components_browser_esm["default"].p(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  line-height: 1.6;\n  margin: 0;\n"])));
var Separator = styled_components_browser_esm["default"].span(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n"])), function (_ref3) {
  var _theme$colors3;
  var theme = _ref3.theme;
  return ((_theme$colors3 = theme.colors) == null ? void 0 : _theme$colors3.textSecondary) || '#666';
});
var Title = styled_components_browser_esm["default"].h2(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 12px;\n  margin-top: 0;\n"])), function (_ref4) {
  var _theme$colors4;
  var theme = _ref4.theme;
  return ((_theme$colors4 = theme.colors) == null ? void 0 : _theme$colors4.textSecondary) || '#666';
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoLinkList/SeoLinkList.js






var SEPARATOR = ' – ';
var getVisibleItems = function getVisibleItems(items, characterLimit) {
  var total = 0;
  var visible = [];
  for (var i = 0; i < items.length; i += 1) {
    var _items$i$label$length, _items$i$label;
    var separatorLength = i > 0 ? SEPARATOR.length : 0;
    var nextTotal = total + separatorLength + ((_items$i$label$length = (_items$i$label = items[i].label) == null ? void 0 : _items$i$label.length) !== null && _items$i$label$length !== void 0 ? _items$i$label$length : 0);
    if (nextTotal > characterLimit) break;
    total = nextTotal;
    visible.push(items[i]);
  }
  return visible;
};
var SeoLinkList = function SeoLinkList(_ref) {
  var staticProps = _ref["static"];
  var _staticProps$characte = staticProps.characterLimit,
    characterLimit = _staticProps$characte === void 0 ? 800 : _staticProps$characte,
    _staticProps$items = staticProps.items,
    items = _staticProps$items === void 0 ? [] : _staticProps$items,
    onClickItem = staticProps.onClickItem,
    title = staticProps.title,
    _staticProps$titleTag = staticProps.titleTag,
    titleTag = _staticProps$titleTag === void 0 ? 'h2' : _staticProps$titleTag;
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var visibleItems = getVisibleItems(items, characterLimit);
  var handleClick = function handleClick(e, item) {
    publish('listlink:click', {
      value: {
        label: item.label
      }
    });
    if (item.targetBlank) return;
    e.preventDefault();
    if (onClickItem) {
      onClickItem(e, item);
      return;
    }
    (0,esm/* routePush */.dY)({
      path: item.href,
      spa: true
    });
  };
  return react.createElement(Container, {
    "data-testid": "seo-link-list"
  }, title && react.createElement(Title, {
    as: titleTag,
    "data-testid": "seo-link-list-title"
  }, title), react.createElement(List, {
    "data-testid": "seo-link-list-list"
  }, visibleItems.length === 0 ? react.createElement("span", {
    "data-testid": "seo-link-list-empty"
  }, "Nenhum link relacionado dispon\xEDvel.") : visibleItems.map(function (item, index) {
    var _item$id;
    return react.createElement(react.Fragment, {
      key: (_item$id = item.id) !== null && _item$id !== void 0 ? _item$id : "".concat(item.label, "-").concat(index)
    }, index > 0 && react.createElement(Separator, {
      "aria-hidden": "true"
    }, SEPARATOR), react.createElement(Link, {
      "data-testid": "seo-link-list-item",
      href: item.href,
      onClick: function onClick(e) {
        return handleClick(e, item);
      },
      rel: item.targetBlank ? 'noopener noreferrer' : undefined,
      target: item.targetBlank ? '_blank' : undefined,
      title: item.title || undefined
    }, item.label));
  })));
};
SeoLinkList.ssr = true;
 false ? 0 : void 0;
SeoLinkList.defaultProps = {
  "static": {}
};
/* harmony default export */ var SeoLinkList_SeoLinkList = ((0,withLayoutProps/* default */.Z)(SeoLinkList));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoLinkList/index.js


/***/ })

}]);